import * as Yup from 'yup';

import history from 'browserHistory';

const departureCommentSchema = () => {
  const pathMode = history.location.pathname.split('/')[1];
  const isDirector = pathMode === 'director';

  return Yup.object().shape({
    entrySecurityMessage: Yup.string().nullable(),
    departureSecurityMessage: Yup.string().nullable(),
    notLoadedMessage: Yup.string().nullable(),
    toleranceMessage: (() => {
      let validation = Yup.string().nullable();
      if (isDirector) {
        validation = validation.required('Вкажіть причину перевищення толерансу');
      }
      return validation;
    })(),
  });
};

export default departureCommentSchema;
